var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGradientCreditCard = function SvgGradientCreditCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5C7.5 21.9107 8.0625 21.4286 8.75 21.4286H13.75C14.4375 21.4286 15 21.9107 15 22.5C15 23.0893 14.4375 23.5714 13.75 23.5714H8.75C8.0625 23.5714 7.5 23.0893 7.5 22.5ZM17.5 22.5C17.5 21.9107 18.0625 21.4286 18.75 21.4286H28.75C29.4375 21.4286 30 21.9107 30 22.5C30 23.0893 29.4375 23.5714 28.75 23.5714H18.75C18.0625 23.5714 17.5 23.0893 17.5 22.5ZM0 4.28571C0 1.91853 2.23828 0 5 0H40C42.7578 0 45 1.91853 45 4.28571V25.7143C45 28.0781 42.7578 30 40 30H5C2.23828 30 0 28.0781 0 25.7143V4.28571ZM2.5 4.28571V6.42857H42.5V4.28571C42.5 3.10246 41.3828 2.14286 40 2.14286H5C3.61953 2.14286 2.5 3.10246 2.5 4.28571ZM2.5 12.8571H42.5V8.57143H2.5V12.8571ZM2.5 15V25.7143C2.5 26.8996 3.61953 27.8571 5 27.8571H40C41.3828 27.8571 42.5 26.8996 42.5 25.7143V15H2.5Z",
    fill: "url(#paint0_linear_3751_59991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3751_59991",
    x1: 45.8437,
    y1: 21.75,
    x2: 18.617,
    y2: -8.40435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3559FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36B2FA"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGradientCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gradient-credit-card.c86f67ad9c0d04bce1ebdb7ddf91c41e.svg";